// lbl.standard_register
export const standard_register = { 
    confirm: "ยืนยัน",
    remark: "หมายเหตุ",
    
    idCard: {
        name: 'หมายเลขบัตรประชาชน',
        placeholder: '',
        required: 'กรุณากรอกหมายเลขบัตรประชาชน',
        too_short: 'กรุณากรอกหมายเลขบัตรประชาชน 13 หลัก',
        invalid: 'หมายเลขบัตรประชาชนไม่ถูกต้อง',
    },
    contactNumber: {
        name: 'หมายเลขโทรศัพท์มือถือ',
        placeholder: '',
        required: 'กรอกหมายเลขโทรศัพท์มือถือ',
        too_short: 'กรุณาระบุหมายเลขโทรศัพท์มือถือให้ครบ 10 หลัก',
        invalid: 'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง',
    },
};
 